import { useEffect, useState } from "react";
import { DesignTokens } from "melco-ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { SummitUsersListFiltersType } from "../../hooks/summit/SummitUsersListFilterType";
import { SelectSummitAddOn } from "./SelectSummitAddOn";
import { SearchSummitUser } from "./SearchSummitUser";
import { StepLabel } from "./summitStyled";

type SummitListFilterProps = {
  onFiltersChange: (filters: SummitUsersListFiltersType | undefined) => void;
  /** Controlled by the parent (SummitList) rather than tracked locally here,
   * so the parent can reset it (e.g. when the user or search changes)
   * and have the Select actually reflect that reset. */
  selectedAddOn: string | undefined;
  setSelectedAddOnCallback: (addon: string) => void;
  setSearchCallback: (searchText: string) => void;
  /** True once a user is selected but no add-on has been chosen — see SelectSummitAddOn. */
  showAddOnRequiredError?: boolean;
};

const { spacings, colors } = DesignTokens;

const SearchHint = styled.p`
  margin-top: 8px;
  font-size: 12px;
  color: ${colors.gray.middle};
  line-height: 1.6;
`;

export const SummitListFilter: React.FC<SummitListFilterProps> = ({
  onFiltersChange,
  selectedAddOn,
  setSelectedAddOnCallback,
  setSearchCallback,
  showAddOnRequiredError,
}) => {
  const { t } = useTranslation();

  const [usersFilter, setSummitFilter] = useState<
    SummitUsersListFiltersType | undefined
  >(undefined);

  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    onFiltersChange(usersFilter);
  }, [usersFilter, onFiltersChange]);

  return (
    <div style={{ padding: `${spacings.middle}px ${spacings.middle}px ${spacings.small}px` }}>
      <StepLabel>{t("summit.form.panel.step_one_label", { defaultValue: "Step 1 — Find user" })}</StepLabel>

      <SearchSummitUser
        onSearchInputChange={(value) => {
          setSummitFilter((prevFilter) => {
            return { ...prevFilter, searchText: value };
          });
        }}
        onChange={(e) => {
          setSearchValue(e.target.value);
          setSearchCallback(e.target.value);
        }}
        value={searchValue}
      />

      <SelectSummitAddOn
        value={selectedAddOn}
        onChange={setSelectedAddOnCallback}
        showRequiredError={showAddOnRequiredError}
      />

      <SearchHint>
        {t("summit.form.panel.search_hint", { defaultValue: "Ask for the caller's name or email." })}
      </SearchHint>
    </div>
  );
};
